module.exports = __webpack_public_path__ + "static/services2-e9db8ec3c0698cc2402c424b5c83df66.jpg";